import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(static)/trademark-academy/article/[slug]/AcademyArticle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
